import { render, staticRenderFns } from "./SetStorageSpaceUpgradeFile.vue?vue&type=template&id=4b59c88d&scoped=true"
import script from "./SetStorageSpaceUpgradeFile.vue?vue&type=script&lang=js"
export * from "./SetStorageSpaceUpgradeFile.vue?vue&type=script&lang=js"
import style0 from "./SetStorageSpaceUpgradeFile.vue?vue&type=style&index=0&id=4b59c88d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59c88d",
  null
  
)

export default component.exports